exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../styles/variables/colors.css"), undefined);

// module
exports.push([module.id, "._2nKL376eERQAMTrkuxCv-h {\n  stroke: " + require("-!../../../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../styles/variables/colors.css").locals["light"] + ";\n}\n", ""]);

// exports
exports.locals = {
	"light": "" + require("-!../../../../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../styles/variables/colors.css").locals["light"] + "",
	"yGrid": "_2nKL376eERQAMTrkuxCv-h"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Graphs/components/YGrid/YGrid.css
// module id = 9777
// module chunks = 23